import appConfig from './apiConfig';

export const submitLoginApi =(loginData)=>{
let objLogin =  JSON.stringify(loginData);

const headers = Object.assign({'content-type':"application/json",
                               'accept':'*/*'});
const request= new Request( appConfig.siteURL+'adminLogin', {

  method : "POST",
  headers : headers,
  body : objLogin
});

return fetch(request).then(response => {
    return  response.json().then(loginResponse => {

      if(loginResponse.success){
        console.log(loginResponse.data[0].Token);
        sessionStorage.setItem('adminEmail', loginResponse.data[0].Email);
        sessionStorage.setItem('adminPassword', loginResponse.data[0].Password);
        sessionStorage.setItem('adminToken', loginResponse.data[0].Token);
      }
      return loginResponse;
    });
  }).catch(error => {
   return error;
 });
}



// WEBPACK FOOTER //
// ./src/api/loginApi.js